/**
* Endpoint methods related to the UserCustomerSubscription
*/

import API from "./Api";

export default {
  /**
  * Gets the Subscription data related to the logged-in user
  */
  async getAllOwn() {

    return API.get("/usercustomersubscription/readallown", "MOODLE_SESSION_JSON");
  }

}